// ============================================================================
// FILE: src/modules/ppe/pages/masters/sku-attributes/SKUAttributeForm.js
// ============================================================================

import React, { useState } from "react";
import skuAttributeService from "./skuAttributeService";
import AttributeValueManager from "./AttributeValueManager";

const SKUAttributeForm = ({ open, onClose, onSuccess, editData }) => {

  const [form, setForm] = useState({
    attribute_code: editData?.attribute_code || "",
    attribute_name: editData?.attribute_name || "",
    data_type: editData?.data_type || "TEXT",
    is_required: editData?.is_required || false
  });

  const [applicability, setApplicability] = useState({
    RAW_MATERIAL: true,
    BOUGHT_OUT: false,
    PRODUCT: false
  });

  const [loading, setLoading] = useState(false);
  const [createdAttributeId, setCreatedAttributeId] = useState(null);

  // ============================================================
  // HANDLERS
  // ============================================================
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleApplicabilityChange = (key) => {
    setApplicability({
      ...applicability,
      [key]: !applicability[key]
    });
  };

  // ============================================================
  // SAVE
  // ============================================================
  const handleSave = async () => {
    try {
      setLoading(true);

      const res = await skuAttributeService.createAttribute(form);

      if (!res.success) {
        alert(res.message);
        return;
      }

      const attrId = res.data.id;
      setCreatedAttributeId(attrId);

      const selectedEntities = Object.keys(applicability).filter(
        (key) => applicability[key]
      );

      for (let entity of selectedEntities) {
        await skuAttributeService.assignApplicability(attrId, {
          entity_type: entity
        });
      }

      if (form.data_type !== "LIST") {
        onSuccess();
      }

    } catch (err) {
      console.error(err);
      alert("Error saving attribute");
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;
  const attributeId = createdAttributeId || editData?.id;

  return (
    <>
      {/* OVERLAY */}
      <div className="drawer-overlay" onClick={onClose} />

      {/* DRAWER */}
      <div className="drawer">

        {/* HEADER */}
        <div className="drawer-header">
          <h3>{editData ? "Edit Attribute" : "Add Attribute"}</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        {/* BODY */}
        <div className="drawer-body">

          {/* CODE */}
          <div className="form-group">
            <label>Attribute Code</label>
            <input
              className="input"
              name="attribute_code"
              value={form.attribute_code}
              onChange={handleChange}
            />
          </div>

          {/* NAME */}
          <div className="form-group">
            <label>Attribute Name</label>
            <input
              className="input"
              name="attribute_name"
              value={form.attribute_name}
              onChange={handleChange}
            />
          </div>

          {/* TYPE */}
          <div className="form-group">
            <label>Data Type</label>
            <select
              className="input"
              name="data_type"
              value={form.data_type}
              onChange={handleChange}
            >
              <option value="TEXT">TEXT</option>
              <option value="NUMBER">NUMBER</option>
              <option value="LIST">LIST</option>
              <option value="BOOLEAN">BOOLEAN</option>
            </select>
          </div>

          {/* REQUIRED */}
          <div className="form-group row">
            <label>Required</label>
            <input
              type="checkbox"
              name="is_required"
              checked={form.is_required}
              onChange={handleChange}
            />
          </div>

          {/* APPLICABILITY */}
          <div className="form-group">
            <label>Applicability</label>

            <div className="checkbox-group">
              {["RAW_MATERIAL", "BOUGHT_OUT", "PRODUCT"].map((key) => (
                <label key={key}>
                  <input
                    type="checkbox"
                    checked={applicability[key]}
                    onChange={() => handleApplicabilityChange(key)}
                  />
                  {key.replace("_", " ")}
                </label>
              ))}
            </div>
          </div>

          {/* VALUE MANAGER 
          //const attributeId = createdAttributeId || editData?.id;
          */}  
          {form.data_type === "LIST" && attributeId && (
            <AttributeValueManager attributeId={attributeId} />
          )}

        </div>

        {/* FOOTER */}
        <div className="drawer-footer">
          <button
            className="btn-secondary"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="btn-primary"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>

      </div>

      {/* STYLES */}
      <style>{`
        .drawer-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.3);
          z-index: 999;
        }

        .drawer {
          position: fixed;
          right: 0;
          top: 0;
          width: 620px;
          height: 100%;
          background: #fff;
          z-index: 1000;
          display: flex;
          flex-direction: column;
          box-shadow: -4px 0 12px rgba(0,0,0,0.15);
        }

        .drawer-header {
          padding: 16px;
          border-bottom: 1px solid #e5e7eb;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .drawer-body {
          padding: 16px;
          overflow-y: auto;
          flex: 1;
        }

        .drawer-footer {
          padding: 16px;
          border-top: 1px solid #e5e7eb;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }

        .form-group {
          margin-bottom: 16px;
        }

        .form-group.row {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .input {
          width: 100%;
          padding: 8px;
          border-radius: 6px;
          border: 1px solid #d1d5db;
          margin-top: 5px;
        }

        .checkbox-group {
          display: flex;
          flex-direction: column;
          gap: 6px;
          margin-top: 6px;
        }

        .btn-primary {
          background: #2563eb;
          color: white;
          border: none;
          padding: 8px 14px;
          border-radius: 6px;
          cursor: pointer;
        }

        .btn-secondary {
          background: #e5e7eb;
          border: none;
          padding: 8px 14px;
          border-radius: 6px;
          cursor: pointer;
        }

        .close-btn {
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
        }
      `}</style>

    </>
  );
};

export default SKUAttributeForm;